export default __webpack_public_path__ + "media/images/coworkr/favicons/icon144-a204fcb8ad4e2a5df24e29f79d39ccb5.png";